import styled from "styled-components";
import { Button } from "../Button";
import { videoButtonSizes } from "../utils";
const centerPlayButton = (size) => {
    switch (size) {
        case videoButtonSizes.medium[0]:
            return "0.5rem";
        case videoButtonSizes.large[0]:
            return "0.625rem";
        case videoButtonSizes.xlarge[0]:
            return "0.75rem";
        default:
            return "0.375rem";
    }
};
export const StyledVideoButton = styled(Button) `
  span {
    display: flex;
    justify-content: center;
    width: ${({ sizes }) => sizes.xsmall[0]}rem;
    height: ${({ sizes }) => sizes.xsmall[0]}rem;

    svg {
      width: ${({ sizes }) => sizes.xsmall[1]}rem;
      margin-left: ${({ sizes }) => centerPlayButton(sizes.xsmall[0])};
    }
  }

  &:active {
    width: ${({ sizes }) => sizes.xsmall[0] + 0.5}rem;
    height: ${({ sizes }) => sizes.xsmall[0] + 0.5}rem;
    margin-left: -0.25rem;
    margin-top: -0.25rem;
    margin-bottom: -2px;
    margin-right: -2px;
  }

  &:disabled:active {
    transform: none;
  }

  @media ${({ theme }) => theme.device.small} {
    span {
      ${({ sizes }) => sizes.small
    ? `width: ${sizes.small[0]}rem; height: ${sizes.small[0]}rem`
    : ""};

      svg {
        ${({ sizes }) => (sizes.small ? `width: ${sizes.small[1]}rem` : "")};
        ${({ sizes }) => sizes.small
    ? `margin-left: ${centerPlayButton(sizes.small[0])}`
    : ""};
      }
    }

    &:active {
      ${({ sizes }) => sizes.small
    ? `width: ${sizes.small[0] + 0.5}rem;
          height: ${sizes.small[0] + 0.5}rem;`
    : ""};
    }
  }

  @media ${({ theme }) => theme.device.medium} {
    span {
      ${({ sizes }) => sizes.medium
    ? `width: ${sizes.medium[0]}rem; height: ${sizes.medium[0]}rem`
    : ""};

      svg {
        ${({ sizes }) => (sizes.medium ? `width: ${sizes.medium[1]}rem` : "")};
        ${({ sizes }) => sizes.medium
    ? `margin-left: ${centerPlayButton(sizes.medium[0])}`
    : ""};
      }
    }

    &:active {
      ${({ sizes }) => sizes.medium
    ? `width: ${sizes.medium[0] + 0.5}rem;
          height: ${sizes.medium[0] + 0.5}rem;`
    : ""};
    }
  }

  @media ${({ theme }) => theme.device.large} {
    span {
      ${({ sizes }) => sizes.large
    ? `width: ${sizes.large[0]}rem; height: ${sizes.large[0]}rem`
    : ""};

      svg {
        ${({ sizes }) => (sizes.large ? `width: ${sizes.large[1]}rem` : "")};
        ${({ sizes }) => sizes.large
    ? `margin-left: ${centerPlayButton(sizes.large[0])}`
    : ""};
      }
    }

    &:active {
      ${({ sizes }) => sizes.large
    ? `width: ${sizes.large[0] + 0.5}rem;
          height: ${sizes.large[0] + 0.5}rem;`
    : ""};
    }
  }

  @media ${({ theme }) => theme.device.xlarge} {
    span {
      ${({ sizes }) => sizes.xlarge
    ? `width: ${sizes.xlarge[0]}rem; height: ${sizes.xlarge[0]}rem`
    : ""};

      svg {
        ${({ sizes }) => (sizes.xlarge ? `width: ${sizes.xlarge[1]}rem` : "")};
        ${({ sizes }) => sizes.xlarge
    ? `margin-left: ${centerPlayButton(sizes.xlarge[0])}`
    : ""};
      }
    }

    &:active {
      ${({ sizes }) => sizes.xlarge
    ? `width: ${sizes.xlarge[0] + 0.5}rem;
          height: ${sizes.xlarge[0] + 0.5}rem;`
    : ""};
    }
  }
`;
